import { render, staticRenderFns } from "./PreferencesNeighborhoods.vue?vue&type=template&id=48c77f9c&"
import script from "./PreferencesNeighborhoods.vue?vue&type=script&lang=js&"
export * from "./PreferencesNeighborhoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports